import { connect } from 'react-redux';
import Moment from 'moment';
import { commonPageInfoReducer } from '../reducers';
import { charts as chartsSelector } from '../selectors';
import { params as paramHelpers } from '../helpers';
import RegressionFailureTrendsComponent
  from '../Components/RegressionFailureTrendsComponent';

const getProductVersionFromParams = (params) => {
  const paramsToCheck = [
    paramHelpers.PROCESS_VERSION,
    paramHelpers.EXAMINE_VERSION,
    paramHelpers.EXE_VERSION,
    paramHelpers.IEF_ENGINE_VERSION
  ];
  const chosenParam = paramsToCheck.find(p => params[p]);
  return chosenParam && params[chosenParam];
};

export const mapStateToProps = (state) => {
  const byTimeChartDataAndLabels = chartsSelector.regressionFailureTrendsDataAndLabels(
    state,
    (_params, scenario) => scenario.created_at,
    (paramValue) => Moment(paramValue).format('MMM-DD'),
    'byTime'
  );
  const byBuildChartDataAndLabels = chartsSelector.regressionFailureTrendsDataAndLabels(
    state,
    (params) => getProductVersionFromParams(params) || 'Unknown Version',
    (paramValue) => paramValue,
    'byBuild'
  );
  const byNodeChartDataAndLabels = chartsSelector.regressionFailureTrendsDataAndLabels(
    state,
    (params) => {
      return params[paramHelpers.NODE] || params[paramHelpers.JENKINS_BUILD_LABEL];
    },
    (paramValue) => paramValue,
    'byNode'
  );

  const props = {
    byTimeChartDataAndLabels,
    byBuildChartDataAndLabels,
    byNodeChartDataAndLabels,
    selectedReason: commonPageInfoReducer.getSelectedFailureReason(state)
  };
  return props;
};

export default connect(
  mapStateToProps
)(RegressionFailureTrendsComponent);

export const testingExports = { getProductVersionFromParams };


// WEBPACK FOOTER //
// src/Containers/RegressionFailureTrendsContainer.jsx